/**
 * 插件浮动层壳层：基于 shadcn `Popover` 将 `PluginIframe` 锚定到子元素（工具栏按钮），
 * 支持点击切换开关与外部点击关闭；高度可随插件 `ui.sizeTo` RPC 调整。
 */
import { useEffect, useState } from "react";

import { Popover, PopoverContent, PopoverTrigger } from "@/shared/ui/popover";

import { PluginIframe } from "./plugin-iframe";

interface PluginPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pluginId: string;
  src: string;
  width?: number;
  height?: number;
  /** 作为定位参考的触发器（通常为工具栏按钮），需为单个子节点 */
  children: React.ReactElement;
}

export function PluginPopup({
  open,
  onOpenChange,
  pluginId,
  src,
  width = 320,
  height = 400,
  children,
}: PluginPopupProps) {
  const [iframeHeight, setIframeHeight] = useState(height);

  useEffect(() => {
    setIframeHeight(height);
  }, [height]);

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        {children}
      </PopoverTrigger>
      <PopoverContent
        align="end"
        side="bottom"
        sideOffset={8}
        collisionPadding={8}
        className="overflow-hidden rounded-lg border bg-popover p-0 shadow-md"
        style={{
          width,
          height: iframeHeight,
          zIndex: 50,
        }}
      >
        <PluginIframe
          pluginId={pluginId}
          src={src}
          onSizeTo={setIframeHeight}
        />
      </PopoverContent>
    </Popover>
  );
}
